var React = require('react');

function Carrotarrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.767953 10.9393C0.182167 11.5251 0.182167 12.4749 0.767953 13.0607L10.3139 22.6066C10.8997 23.1924 11.8494 23.1924 12.4352 22.6066C13.021 22.0208 13.021 21.0711 12.4352 20.4853L3.94993 12L12.4352 3.51472C13.021 2.92893 13.021 1.97918 12.4352 1.3934C11.8494 0.807611 10.8997 0.807611 10.3139 1.3934L0.767953 10.9393ZM3.82861 10.5L1.82861 10.5L1.82861 13.5L3.82861 13.5L3.82861 10.5Z","fill":"white"}));
}

Carrotarrow.defaultProps = {"width":"13","height":"24","viewBox":"0 0 13 24","fill":"none"};

module.exports = Carrotarrow;

Carrotarrow.default = Carrotarrow;
